module.exports = __webpack_public_path__ + "static/img/logo.96d800b3.svg";